var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPersonalMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10418:23422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38.0968L46 0L92 38.0968V92H0V38.0968Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9861 70.386H15.0139C14.55 70.386 14.174 70.0105 14.174 69.5469V8.67827C14.174 8.21538 14.55 7.83984 15.0139 7.83984H76.9861C77.4501 7.83984 77.8261 8.21538 77.8261 8.67827V69.5469C77.8261 70.0105 77.4501 70.386 76.9861 70.386Z",
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7225 41.5275C21.7225 40.469 22.5807 39.6108 23.6392 39.6108H67.8059C68.8644 39.6108 69.7225 40.469 69.7225 41.5275C69.7225 42.586 68.8644 43.4442 67.8059 43.4442H23.6392C22.5807 43.4442 21.7225 42.586 21.7225 41.5275Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 47,
    width: 48,
    height: 3.83333,
    rx: 1.91666,
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 48,
    height: 3.83333,
    rx: 1.91666,
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4443 21.0832C43.4443 20.0246 44.3025 19.1665 45.361 19.1665H68.361C69.4195 19.1665 70.2777 20.0246 70.2777 21.0832C70.2777 22.1417 69.4196 22.9998 68.361 22.9998H45.361C44.3025 22.9998 43.4443 22.1417 43.4443 21.0832Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4445 28.7502C43.4445 27.6916 44.3026 26.8335 45.3611 26.8335H58.1389C59.1974 26.8335 60.0556 27.6916 60.0556 28.7502C60.0556 29.8087 59.1975 30.6668 58.1389 30.6668H45.3611C44.3026 30.6668 43.4445 29.8087 43.4445 28.7502Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 19.1665H23.7222C22.6176 19.1665 21.7222 20.0619 21.7222 21.1665V28.6665C21.7222 29.7711 22.6176 30.6665 23.7222 30.6665H36.3333C37.4378 30.6665 38.3333 29.7711 38.3333 28.6665V21.1665C38.3333 20.0619 37.4378 19.1665 36.3333 19.1665Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.0967L38.1465 65.0486L0 91.9998V38.0967Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 38.0967L53.8535 65.0486L92 91.9998V38.0967Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8854 65.0486H38.1465V65.0259L0 91.9999H92L53.8854 65.0486Z",
    fill: "#D01533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10418:23422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPersonalMail);
export default __webpack_public_path__ + "static/media/imgPersonalMail.3aef3345b989b6de54e6ba12dee55345.svg";
export { ForwardRef as ReactComponent };